export default require('../otherChains/bobTestnet').default.rpcUrls.default.http[0]